export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img4-49f6c3e729850a4df6ea4331a7d845fa.png";